// extracted by mini-css-extract-plugin
export default {"Container":"FooterInfo_Container__6wmv6","Badges":"FooterInfo_Badges__y5-aG"};